import { useApiContext } from "../../api/ApiProvider";
import useEventId from "../../util/useEventId";
import type { ReservationState } from "../../util/useReservationState";
import { FloatingConfirmUI } from "../FloatingUI";
import { FormWrapper } from "../FormWrapper";
import ReservationSummary from "../ReservationSummary";
import { ResponsiveStack } from "../ResponsiveStack";
import Space from "../Space";

export default function Form3({ state }: { state: ReservationState }) {
  const { api } = useApiContext();
  const eventId = useEventId();
  const onPrev = () => {
    state.setValue("confirmed", false);
  };

  const onNext = () => {
    if (state.data.posted) {
      return;
    }
    state.setValue("posted", true);
    api.PostReserve(state.data, eventId, new URLSearchParams(window.location.search)).then((response) => {
      if (response) {
        state.setValue("rid", response.rid);
        state.setValue("lineLoginUrl", response.line_login_url);
        state.setValue("accepted", true);
      } else {
        state.setValue("error", true);
      }
    });
  };

  if (!state.data.store || !state.data.course || !state.data.date) {
    state.setValue("error", true);
    return null;
  }

  return (
    <FormWrapper currentIndex={2} skipConfirm={state.data.store?.skip_confirm}>
      <ReservationSummary data={{ ...state.data, course: state.data.course, date: state.data.date, nominated_staff: state.data.staff ?? null, store: state.data.store }} />
      <Space h={250} />
      <ResponsiveStack columnReverse style={{ alignItems: "center", gap: 10 }}>
        <FloatingConfirmUI onNext={onNext} onPrev={onPrev} />
      </ResponsiveStack>
    </FormWrapper>
  );
}
